import React from 'react';
import classNames from 'classnames/bind';
import { H2 } from '../Typography';

import styles from './EmptyState.module.scss';

const cx = classNames.bind(styles);

interface EmptyStateProps {
  actions?: React.ReactNode;
  className?: string;
  style?: { [key: string]: string };
  title?: string;
  titleClass?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  actions,
  className,
  style = {},
  title,
  titleClass,
}) => {
  const emptyStateClassNames = cx('empty-state', className);

  return (
    <div className={emptyStateClassNames} style={style}>
      {title && (
        <H2 className={cx('empty-state__title', titleClass)}>{title}</H2>
      )}
      {actions && <div className={cx('empty-state__actions')}>{actions}</div>}
    </div>
  );
};

export default EmptyState;
